import React, { useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useStore } from '../../../store';
import { IInputValue } from '../../../domains/common.domain';
import useRegisterErrorField from '../hooks/register-error-field-hook';

export interface ISelectValue {
  label: string;
  value: string;
}

interface ISelectInputProps {
  value: IInputValue<string> | IInputValue<string | null>;
  label: string;
  error?: string;
  warning?: string;
  customError?: string;
  selectLabel?: string;
  onUpdate: (value: string) => void;
  selectValues: ISelectValue[];
  disabled?: boolean;
}

const SelectInput = observer((props: ISelectInputProps) => {
  const { value, label, error = '', customError, warning, onUpdate, selectLabel, selectValues, disabled = false } = props;
  const fieldRef = useRef<HTMLDivElement | null>(null);
  useRegisterErrorField(fieldRef, value.errorType);
  const { signUpStore } = useStore();

  return (
    <div className={'container-input'} ref={fieldRef}>
      <label>{label}</label>
      <div className={'controls'}>
        <select
          className={classNames(error && value.errorType && signUpStore.showErrors && 'error')}
          value={value.value ?? ''}
          onChange={e => onUpdate(e.target.value)}
          disabled={disabled}
        >
          {selectLabel && <option value={''}>{selectLabel}</option>}
          {selectValues.map(value => (
            <option key={value.label} value={value.value}>
              {value.label}
            </option>
          ))}
        </select>
        {error && value?.errorType && signUpStore.showErrors && <label className={'error'}>{error}</label>}
        {customError && value?.errorType && <label className={'custom-error'}>{customError}</label>}
        {warning && value?.warningType && <label className={'warning'}>{warning}</label>}
      </div>
    </div>
  );
});

export default SelectInput;
